import { Text, View } from 'react-native';

export default () => (
  <View>
    <Text>检查权限 </Text>
  </View>
);
